import React, { Component } from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { getPricing } from '../../actions/pay.js';
import { getSession1, updatePaperInput, updateStep3, updateSpecialInstruction,UpdateExtrasDifference, updateSpecialInstructionFile } from '../../actions/paper.js';
import calculatePrice from '../../util/calculatePrice';
import { trackPage } from '../../util/analytics.js';
import Dropzone from 'react-dropzone';
import classname from 'classnames';
import { openExtraModal, openCitationMenu, closeCitationMenu, closeExtraModal, OpenFAQModal, CloseFAQModal, openBronzeExampleModal, closeBronzeExampleModal, openSilverExampleModal, closeSilverExampleModal, openGoldExampleModal, closeGoldExampleModal } from '../../actions/modals.js';
import ReactModal from 'react-modal';
import FAQ from './FAQ';
import TopNav from '../includes/TopNav.js';
import Footer from '../pages/Footer.js';
import FileInput from 'react-file-input';
import ReactTooltip from 'react-tooltip';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import {Helmet} from 'react-helmet';
import Bubbles from './Bubbles';

class Step3Page extends Component{
  constructor(props) {
    super(props);
    this.state = {
      menuActive: false
    };
    this.updateInstructions = null;
    this.props.dispatch(getPricing());
    this.props.dispatch(getSession1(function(){
      var data = calculatePrice(this.props.Paper);
    }.bind(this)));
    
  }
  componentDidMount(){
    trackPage('step3');
  }
  openCitationMenu (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.dispatch(openCitationMenu());
  }
  closeCitationMenu(){
    this.props.dispatch(closeCitationMenu());
  }
  stopPropagation(e){
    e.preventDefault();
    e.stopPropagation();
  }
  updateCitationNumber(e){
    console.log("checking citaion number: ");
    console.log(e.target.value);
    e = 'citation_number_' + e.target.value;
    this.props.dispatch(updateStep3(e,this.props.Paper.paper.extras));
    var data = calculatePrice(this.props.Paper);
    this.props.dispatch(UpdateExtrasDifference(data.extras_price));
  }
  updatePaper(e){
    this.props.dispatch(updateStep3(e,this.props.Paper.paper.extras));
    var data = calculatePrice(this.props.Paper);
    this.props.dispatch(UpdateExtrasDifference(data.extras_price));
  }
  updateSpecialInstruction(e){
    clearTimeout(this.updateInstructions);
    this.props.dispatch(updateSpecialInstruction(e.target.value));
    this.updateInstructions = setTimeout(function() {
      this.props.dispatch(updatePaperInput('instructions', this.props.Paper.paper.instructions));
    }.bind(this),1000);
  }
  ChangeStep(level){
    window.scrollTo(0, 0);
  }
  onDrop = (paper, reject) => {
    this.props.dispatch(updateSpecialInstructionFile(paper.target.files[0]));
  }
  OpenFAQModal(e){
    this.props.dispatch(OpenFAQModal());
  }
  CloseFAQModal(e){
    this.props.dispatch(CloseFAQModal());
  }
  closeExtraModal(e){
    this.props.dispatch(closeExtraModal());
  }
  render() {
    const placeholderText = "Specific editor? Different editor? Specific citation style such as APA or MLA? We'll try to accommodate your request. Select the appropriate options on this page that correspond to your request.";
    console.log("rendering step3 with ")
    console.log(this.props.Paper.paper);
    var active_ESL = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('ESL') > -1),
      'top-borders': true
    });
    var active_extraEditing = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('ExtraEditing') > -1)
    });
    var active_Critiques = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('Critiques') > -1)
    });
    var active_extraComments = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('extraComments') > -1)
    });
    var active_Formatting = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('Formatting') > -1)
    });
    var active_GradeMyPaper = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('gradeMyPaper') > -1),
      'bottom-borders': true
    });
    var active_plagiarism = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('Plagiarism') > -1)
    });
    var active_CitationCorrection = classname({
      'extras-wrap': true,
      'extras-wrap-active': (this.props.Paper.paper.extras.indexOf('CitationCorrection') > -1)
    });
    var dropdown_extras = classname({
      'dropdown-extras': true,
      'dropdown-closed': !this.props.Modals.citation_dropdown
    });

    return (
      <div>
        <Helmet>
          <title>Step 3- Document Extras | Edit My Paper </title>
          <meta name="description" content="Use Our Quick Submission Process for Easy Document Uploading and Professional Paper Editing."></meta>
        </Helmet>
      <ReactTooltip className="step-tooltips"/>
      <ReactModal
       isOpen={this.props.Modals.faq_modal}
       contentLabel="FAQ Modal"
       className="faq-modal"
      >
      <div className="modal-header">
        <div className="modal-header-text">FAQ</div>
        <i className="fa fa-times faq-modal-close fa-2x" aria-hidden="true" onClick={this.CloseFAQModal.bind(this)} value="Close"></i>
      </div>
      <FAQ />
      </ReactModal>
      <TopNav inSteps={true}/>
      <section className="steps top_section">
      <Bubbles currentStep={3}></Bubbles>
      <br/><br/><br/>
      </section>
      <section className="extras">
        <div className="container">
          <div className="row">
            <div className="container-fluid">
              <div className="extras_wrapper">
                <div className="extra_block">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="left-block bg-light">
                         <h2 className="title text-center">Extras</h2>
                          <ul className="extras_listing">
                            <li onClick={this.updatePaper.bind(this, 'ESL')} >
                              <p className="list_item has_tooltip_left" className={active_ESL}>
                              <span className="extras-title">ESL</span>
                              <i className="extras-info fa fa-question-circle" aria-hidden="true" data-tip="If English is your second language (ESL) we recommend choosing this option to ensure your paper is edited accordingly."></i>
                                <span className="pull-right">Starting from $10</span>
                              </p>
                            </li>
                            <li onClick={this.updatePaper.bind(this, 'ExtraEditing')}>
                              <p className="list_item has_tooltip_left" className={active_extraEditing}>
                              <span className="extras-title">Extra Editing</span>
                              <i className="extras-info fa fa-question-circle" aria-hidden="true" data-tip="If you want your editor to provide you with more in-depth editing or if your paper is poorly written."></i>
                                <span className="pull-right">Starting from $10</span>
                              </p>
                            </li>
                            <li onClick={this.updatePaper.bind(this, 'extraComments')}>
                              <p className="list_item has_tooltip_left" className={active_extraComments}>
                              <span className="extras-title">Extra Comments</span>
                              <i className="extras-info fa fa-question-circle" aria-hidden="true" data-tip="Our editor will leave you additional guiding comments."></i>
                                <span className="pull-right">Starting from $10</span>
                              </p>
                            </li>
                            <li onClick={this.updatePaper.bind(this, 'Critiques')}>
                              <p className="list_item has_tooltip_left" className={active_Critiques}>
                              <span className="extras-title">Critiques</span>
                              <i className="extras-info fa fa-question-circle" aria-hidden="true" data-tip="Your editor will critique your paper by commenting on its overall style and further elaborate on any errors that need to be corrected in your writing. Warning: Your editor will be honest and you may not like what he/she says!"></i>
                                <span className="pull-right">Starting from $10</span>
                              </p>
                            </li>
                            <li onClick={this.updatePaper.bind(this, 'Formatting')}>
                              <p className="list_item has_tooltip_left" className={active_Formatting}>
                              <span className="extras-title">Formatting</span>
                              <i className="extras-info fa fa-question-circle" aria-hidden="true" data-tip="Your editor will ensure your paper conforms to university standards by fixing: font, paragraph splitting/splicing, text size, page numbers, and adding a date. If recommended, they will add a cover page/top page. Specify your formatting style in the Special Instructions box to your right."></i>
                                <span className="pull-right">Starting from $10</span>
                              </p>
                            </li>
                            <li onClick={this.updatePaper.bind(this, 'CitationCorrection')} >
                              <p className="list_item has_tooltip_left" className={active_CitationCorrection}>
                              <span className="extras-title">Citation Correction</span>
                              <i className="extras-info fa fa-question-circle" aria-hidden="true" data-tip="We will correct up to 10 of your Works Cited / Bibliography citations. Contact us if you have more than 10 citations you need checked. Mention in the Special Instructions your citation type."></i>
                                {/* ----- REMOVING FOR NOW, WILL BE RE-ADDED LATER ------
                                <span onClick={this.openCitationMenu.bind(this)} className="open-citation-menu">. . .</span>
                                <div className={dropdown_extras} onClick={this.stopPropagation.bind(this)}>
                                  <ul>
                                    <li className="citation-menu-list"># of Citations: <input type="number" className="citation-input" onChange={this.updateCitationNumber.bind(this)} />           </li>
                                    <li className="citation-menu-list"><label onClick={this.updatePaper.bind(this, 'MLA')}><input id="checkBox" type="checkbox" className="right-check" />MLA             </label></li>
                                    <li className="citation-menu-list"><label onClick={this.updatePaper.bind(this, 'APA')}><input id="checkBox" type="checkbox" className="right-check" />APA             </label></li>
                                    <li className="citation-menu-list"><label onClick={this.updatePaper.bind(this, 'Other_citation')}><input id="checkBox" type="checkbox" className="right-check" />Other</label> <input type="text" className="citation-input" onChange={this.updateCitationNumber.bind(this)} />   </li>
                                    <div className="citation-accept" onClick={this.closeCitationMenu.bind(this)}>Accept</div>
                                  </ul>
                                </div>
                                */}
                                <span className="pull-right">Starting from $10</span>
                              </p>
                            </li>
                            <li onClick={this.updatePaper.bind(this, 'Plagiarism')}>
                              <p className="list_item has_tooltip_left" className={active_plagiarism}>
                              <span className="extras-title">Plagiarism Scan &amp; Report</span>
                              <i className="extras-info fa fa-question-circle" aria-hidden="true" data-tip="We will scan your paper through a private, secure, non-public plagiarism checker and provide you with a report highlighting the areas caught, if any. Having your paper scanned will NOT affect any scan done by your teacher/professor."></i>
                                <span className="pull-right">Starting from $10</span>
                              </p>
                            </li>
                            <li onClick={this.updatePaper.bind(this, 'gradeMyPaper')}>
                              <p className="list_item has_tooltip_left" className={active_GradeMyPaper}>
                              <span className="extras-title">Grade My Paper</span>
                              <i className="extras-info fa fa-question-circle" aria-hidden="true" data-tip="Your editor will provide an approximate grade and opinion of your paper. The grade is not guaranteed as it is ultimately up to your professor."></i>
                                <span className="pull-right">Starting from $10</span>
                              </p>
                            </li>
                          </ul>
                        <h3 className="extra_total_price">+${this.props.Paper.extras_price}</h3>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="right-block bg-light">
                        <h2 className="title text-center">Special Instructions <i className="extras-info fa fa-info-circle" aria-hidden="true" data-tip="Want to tell your editor something or write a brief description of your paper? Write any suggestions that your editor should keep in mind while editing. Please note that your editor will not be able to do anything other than edit your work. If you have a French, German or Spanish language document that needs editing, please email info@editmypaper.ca or chat with us before uploading your paper."></i></h2>
                        <textarea 
                          placeholder={placeholderText}
                          maxLength="430" onChange={this.updateSpecialInstruction.bind(this)} 
                          value={this.props.Paper.paper.instructions}></textarea>
                        <h5 className="words_left">{(430 - this.props.Paper.paper.special_instructions.length)} characters left</h5>
                        <div className="step-3-doc-title">{this.props.Paper.paper.special_instructions_file || ''}</div>
                        <FileInput name="myImage"
                                   accept=".png,.gif"
                                   placeholder="My Image"
                                   className="inputClass"
                                   onChange={this.onDrop} />
                        <div className="fixed_button_wrapper">
                          <label className="button style2 upload gray">
                            <input type="file" className="hidden-input" onChange={this.onDrop.bind(this)} />
                            Upload Supporting File
                          </label><br /><br />
                          {this.props.Paper.paper.instructions_file}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="price_counter">
                  <div className="price_counter_wrapper">
                    <div className="package silver">
                      <i className="fa fa-trophy package_trophy" aria-hidden="true"></i>
                    </div>
                    <div className="price">
                      <p className="price_details">${this.props.Paper.paper.doc_cost || 0.00 }</p>
                    </div>
                    <div className="words">
                      <p className="words_count">for <span>{this.props.Paper.paper.word_count}</span>  words</p>
                    </div>
                  </div>
                </div>
                <div className="question">
                <div className="faq-opener" onClick={this.OpenFAQModal.bind(this)}>View editing service FAQs</div>
                </div>
                <div className="button_wrapper button_center">
                  <Link to="/step2" className="button back">
                  <svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                          <g id="Step-2.1A-FAQ" transform="translate(-200.000000, -945.000000)" stroke="#419BF9">
                              <g id="Group-9" transform="translate(188.000000, 936.000000)">
                                  <g id="Group-16" transform="translate(0.857143, 0.000000)">
                                      <g id="Group-16-Copy" transform="translate(47.000000, 13.500000) scale(1, -1) translate(-47.000000, -13.500000) ">
                                          <path d="M12.4229503,17.2913356 L16.5101983,13.2040874" id="Line" transform="translate(14.785714, 15.500000) scale(1, -1) translate(-14.785714, -15.500000) "></path>
                                          <path d="M12.4229503,13.2913356 L16.5101983,9.20408739" id="Line"></path>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </svg> back
                  </Link>
                    <Link to="/step4" className="button next" onClick={this.ChangeStep}>Next
                      <svg className="next-arrow" width="43px" height="43px" viewBox="0 0 43 43" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                        <defs></defs>
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="Step-1.2.2-w-Estimate" transform="translate(-745.000000, -845.000000)" stroke="#FFFFFF">
                            <g id="Group-15" transform="translate(746.000000, 846.000000)">
                              <circle id="Oval-11" cx="20.5" cy="20.5" r="20.5"></circle>
                              <g id="Group-14" transform="translate(17.000000, 12.000000)" strokeLinecap="square">
                                <path d="M0.357142857,0.357142857 L9.64285714,9.64285714" id="Line"></path>
                                <path d="M0.357142857,18.6428571 L9.64285714,9.35714286" id="Line-Copy-3"></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
      </div>
    )
  }
}

export default connect(
  ({Paper, Modals})=>({Paper, Modals})
)(Step3Page);

// <h3 className="extra_total_price">+$20.00</h3>
// <header className="header">
//   <div className="container">
//     <div className="row">
//       <nav className="navbar ">
//         <div className="container-fluid">
//           <div className="navbar-header">
//             <a className="navbar-brand" href="/"><img src="extras_files/logo.png" className="logo" alt="Edit_My_Paper_logo" /></a>
//             <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
//               <span className="icon-bar"></span>
//               <span className="icon-bar"></span>
//               <span className="icon-bar"></span>
//             </button>
//           </div>
//           <div className="collapse navbar-collapse">
//             <ul className="nav navbar-nav">
//               <li className="active"><a href="/">get started</a></li>
//               <li><a href="#">Our Process</a></li>
//               <li><a href="#">Blog</a></li>
//               <li><a href="#">Edit Tiers</a></li>
//               <li><a href="#">Contact</a></li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </div>
//   </div>
// </header>
// <div className="container">
//   <div className="row">
//     <div className="container-fluid">
//       <div className="steps_wrapper">
//         <div className="step_item">
//           <a href="/" className="step_item_number">
//           <i className="fa fa-check" aria-hidden="true"></i>
//           <span className="step_item_title">Upload</span>
//           </a>
//         </div>
//         <div className="step_item">
//           <a href="/step2" className="step_item_number">
//           <i className="fa fa-check" aria-hidden="true"></i>
//             <span className="step_item_title">Pricing</span>
//           </a>
//         </div>
//         <div className="step_item active">
//           <a href="/step3" className="step_item_number">
//             3
//             <span className="step_item_title">Extras</span>
//           </a>
//         </div>
//         <div className="step_item">
//           <a href="/step4" className="step_item_number">
//             4
//             <span className="step_item_title">Checkout</span>
//           </a>
//         </div>
//       </div>
//     </div>
//   </div>
// </div>



// WEBPACK FOOTER //
// ./src/components/steps/step3.js